export * from './create-setup-intent'
export * from './get-payment-method'
export * from './get-payment-methods'
export * from './remove-payment-method'
export * from './update-payment-method'


export const stripeBaseUrl = import.meta.env.VITE_VIRTUAL_CARD_BASE_URL